import russianMessages from 'ra-language-russian';

export const customRussianMessages = {
    ...russianMessages,
    custom: {
        upload: {
            list_icon_success: 'Иконка в списке успешно загружена',
            list_icon_deleted: 'Иконка в списке удалена',
            gallery_images_success: 'Загружено %{count} изображений',
            gallery_image_deleted: 'Изображение удалено',
            uploading: 'Загрузка...',
            error: 'Ошибка загрузки: %{error}',
        }
    },
    resources: {
        'admin-users': {
            name: 'Учетная запись |||| Учетные записи',
            fields: {
                username: 'Логин',
                password: 'Пароль',
                is_active: 'Активна',
                created_at: 'Создана',
                updated_at: 'Обновлена',
            },
        },
    },
    // Добавляем прямые переводы для наших сообщений
    'Иконка в списке успешно загружена': 'Иконка в списке успешно загружена',
    'Иконка в списке удалена': 'Иконка в списке удалена',
    'Изображение удалено': 'Изображение удалено',
    'Загружено %{count} изображений': 'Загружено %{count} изображений',
    'Ошибка загрузки: %{error}': 'Ошибка загрузки: %{error}',
};
